/* Staffel-Hinweis im Warenkorb-Drawer (snippets/staffel-hint-line.liquid): "X dazulegen" legt die fehlende Menge nach */
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-staffel-add]');
  if (!button || button.disabled) return;
  button.disabled = true;
  fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(button.dataset.staffelAdd), quantity: parseInt(button.dataset.qty, 10) || 1 }] })
  }).then(function () {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }).catch(function () {
    button.disabled = false;
  });
});

/* /cart leitet auf /?cart=open um (layout/theme.liquid): dort den Warenkorb-Drawer öffnen und den Parameter entfernen */
(function () {
  var params = new URLSearchParams(location.search);
  if (params.get('cart') !== 'open') return;
  params.delete('cart');
  var clean = location.pathname + (params.toString() ? '?' + params.toString() : '') + location.hash;
  history.replaceState(history.state, '', clean);
  customElements.whenDefined('cart-drawer').then(function () {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && drawer.show) setTimeout(function () { drawer.show(); }, 300);
  });
})();
